// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 953) return "static/chunks/953.688f7d608b586223.js";
	if (chunkId === 966) return "static/chunks/966.ea3dd95b73612968.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"349":"5a78f0cb5bb4fe05","489":"0b2dc0035112d422","495":"05dc12c3ab567141","634":"92eb31d40b2b9998"}[chunkId] + ".js";
};